<template>
  <div v-if="loadingPage" class="load-parent" style="z-index: 10">
    <div class="loader"></div>
  </div>

  <component :is="currentLayout" />
  <div class="fixed-div" v-if="showNewRequest">

    <i @click="showNewRequest = false" class="fa-regular fa-close"></i>

    <NewRequestView :isComponent2="true" @close-modal="showNewRequest = false" :eventData="eventData"/>


  </div>


  <v-snackbar
      v-model="$store.state.snackbar.show"
      :color="$store.state.snackbar.color"
      :timeout="3000"
  >
    {{ $store.state.snackbar.text }}
    <template v-slot:actions>
      <v-btn

          variant="tonal"
          @click="$store.dispatch('snackbar/hide')"
      >
        بستن
      </v-btn>
    </template>
  </v-snackbar>
</template>


<style lang="scss">
.fixed-div {
  position: fixed;
  left: 0;
  background: #fff;
  right: 0;
  width: 100%;
  top: 0;
  height: 100%;
  max-height: 100vh;
  overflow: auto;
  z-index: 4;

  > i {
    font-size: 20px;
    margin: 20px;
    position: absolute;
    left: 0;
    top: 0;
    cursor: pointer;
    transition: all ease .4s;

    &:hover {
      opacity: .7;
    }
  }

}

#app {
  width: 100%;
}


</style>
<script setup>
import {ref, computed, onMounted, onBeforeUnmount, watch, defineAsyncComponent} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import store from "@/store";
import axios from "axios";
import NewRequestView from "@/views/management/NewRequestView";
import {useUserStore} from "@/store/user";
import {useUploadBlockStore} from "@/store/uploadBlock";

const LayoutComponent = defineAsyncComponent(() => import('@/components/admin/Layout'))
const LayoutManagementComponent = defineAsyncComponent(() => import('@/components/management/LayoutManagement'))
const LayoutCallCenter = defineAsyncComponent(() => import('@/components/callCenter/LayoutCallCenter'))
const currentLayout = computed(() => {
  const path = route.path.toLowerCase()
  const name = route.name?.toString().toLowerCase() || ''

  if (path.includes('/call-center') || name.includes('call-center')) {
    return LayoutCallCenter
  }
  if (admin.value) {
    return LayoutComponent
  }



  return LayoutManagementComponent
})
const route = useRoute()
const router = useRouter()

const apiBaseUrl = window.appConfig.API_URL_BASE
const admin = ref(false)
const loadingPage = ref(false)
const apiInterval = ref('')
const showNewRequest = ref(false)
const userInfo = ref('')
const eventData = ref('')
const active_operator = ref(0)
const getHeaders = () => ({
  'Accept': 'Application/json',
  'Content-Type': 'Application/json',
  'Authorization': 'Bearer ' + (localStorage.getItem('token') || '')
})
const isLogOut = computed(() => store.getters.getLogOut)


const userData = computed(() => store.getters.getUserData)
const roleChange = computed(() => store.getters.getPanelRole)

const startPolling = () => {

  apiInterval.value = setInterval(() => {
    const token = localStorage.getItem('token')
    if(!token) return
    axios.post(apiBaseUrl + 'api/total-functions',
        {token:token}, {headers: getHeaders()})
        .then(res => {
          let event = res.data.getNewEvents.events[0]
          if (res.data.getNewEvents.total !== 0) {
            showNewRequest.value = true
            eventData.value = event.data
          }
          active_operator.value = res.data.active_operator

          store.commit('setActiveOperator', active_operator.value);
          if (userInfo.value?.data?.active_operator !== active_operator.value) {
            logout()

          }

        })
        .catch(error => {
          console.error('API error:', error);
        });
  }, 9000);
}
const userStore = useUserStore()
watch(
    () => [route.matched, userStore.getSettings],
    () => {
      const settings = userStore.getSettings
      const siteTitle = Array.isArray(settings)
          ? settings.find(item => item.key === 'title')?.value
          : ''
      const routeTitle = [...route.matched].reverse().find(item => item.meta?.title)?.meta.title
      document.title = [routeTitle, siteTitle]
          .filter(value => typeof value === 'string' && value.trim())
          .map(value => value.trim())
          .join(' | ') || 'سامانه'
    },
    {immediate: true}
)
const getPublicSetting = async () => {
  const url = apiBaseUrl + 'api/settings/public'

  try {
    const res = await axios.get(url, {headers: getHeaders()})
    if (!res) return

    const settings = res.data?.data?.settings || []

    userStore.setSettings(settings)
    userStore.clearBan()
    const otpEnabled = settings.find(item => item.key === 'otp_enabled')

    if (otpEnabled?.value !== undefined) {
      store.commit('setOtpEnabled', otpEnabled.value)
    }


  } catch (err) {
    const status = err?.response?.status

    if (status === 403) {
      userStore.setBan(true, err.response.data.message)

    }

    if (status === 503) {
      await  router.push({name: 'Error503'})
    }

    console.warn('getPublicSetting failed silently')
  }finally {
    console.warn('getPublicSetting failed silently')
  }
}


const getUserInfo = async () => {
  loadingPage.value = true
  const token = localStorage.getItem('token')

  try {
    await userStore.loadUser(token)
    userInfo.value = userStore.userInfo

    const panelRole = +localStorage.getItem('panel-role')
    const permissionsSystem = userInfo.value?.data?.permissions?.some(item => item.category === "system")

    admin.value = (panelRole === 1) && (permissionsSystem)
  } catch (err) {
    loadingPage.value = false
    if (err?.response?.status === 422 && err?.response?.data?.password_must_change) {
      router.push({name:'newPassword'})
      return
    }
    console.error('getUserInfo error:', err)
  } finally {
    loadingPage.value = false
  }
}

const logout = async () => {
/*
  router.push('/auth/login')
  store.commit('setMobile', '')
  userStore.clearUser()
  localStorage.removeItem('panel-role')
  store.commit('setLogin', false);
  localStorage.removeItem('token')

  let url = apiBaseUrl + 'api/logout'
  await axios.post(url, '', {headers: getHeaders()}).then(() => {

  }).catch(err => {
    console.log(err)
  })
*/


}




onMounted(() => {
  getUserInfo()
  getPublicSetting()
  const uploadStore = useUploadBlockStore()
  uploadStore.init()

  if (localStorage.getItem('token') && window.appConfig.NODE_ENV === 'production') startPolling()
})
onBeforeUnmount(() => {
  clearInterval(apiInterval.value);
})

watch(() => isLogOut.value, (val) => {
  if (val) {
    logout()
  }
})
watch(roleChange, (newData) => {
  if (newData == 1) {
    admin.value = true
  } else {
    admin.value = false
  }

})
watch(userData, () => {
  let panelRole = localStorage.getItem('panel-role')

  if (!panelRole) {
    if (panelRole == 1) {
      admin.value = true
    } else {
      admin.value = false
    }
    return
  }

})



</script>
